import { LogTypeEnum } from '../enums/logType/log-type.enum';
export class Constants {
    static INFO_COMPONENTS = {
        imageInfo: LogTypeEnum.image,
        messageInfo: LogTypeEnum.message,
        movedDetails: LogTypeEnum.damageMoved,
        image: LogTypeEnum.damageMoved,
        commentInfo: LogTypeEnum.detailed,
        repair_centers: LogTypeEnum.list,
        pieces_list: LogTypeEnum.list,
        repairCenterInfo: LogTypeEnum.detailed,
        conceptInfo: LogTypeEnum.concept,
        field: LogTypeEnum.text,
        newValue: LogTypeEnum.text,
        oldValue: LogTypeEnum.text,
        blockedInfo: LogTypeEnum.blocked,
        workshopInformation: LogTypeEnum.damageUpdated
    };
    static LOG_LANG_KEYS = {
        paint_system_changed: LogTypeEnum.paintSystemUpdated,
        damage_changed: LogTypeEnum.damageChanged,
        company_damage_changed: LogTypeEnum.damageChanged,
        custom_damage_changed: LogTypeEnum.damageChanged
    };
    static SIDE_PICTURES = {
        // Estructura básica de las imágenes 360
        car: [
            {
                id: 'front',
                name: 'Front',
                name_es: 'Parte delantera',
                type: 'front',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFront',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'rear',
                name: 'Rear',
                name_es: 'Parte trasera',
                type: 'rear',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRear',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'rear-left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'rearLeft',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newLeft',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'front-left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'frontLeft',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFrontLeft',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'rear-right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'rearRight',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRight',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'front-right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'frontRight',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFrontRight',
                uploadOK: true,
                enableAI: true
            }
        ],
        moto: [
            {
                id: 'front',
                name: 'Front',
                name_es: 'Parte delantera',
                type: 'front',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFront',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'rear',
                name: 'Rear',
                name_es: 'Parte trasera',
                type: 'rear',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRear',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'left',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newLeft',
                uploadOK: true,
                enableAI: true
            },
            {
                id: 'right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'right',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRight',
                uploadOK: true,
                enableAI: true
            }
        ],
        truck: [
            {
                id: 'front',
                name: 'Front',
                name_es: 'Parte delantera',
                type: 'front',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFront',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'rear',
                name: 'Rear',
                name_es: 'Parte trasera',
                type: 'rear',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRear',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'rear-left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'rearLeft',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newLeft',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'front-left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'frontLeft',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFrontLeft',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'rear-right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'rearRight',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRight',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'front-right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'frontRight',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFrontRight',
                uploadOK: true,
                enableAI: undefined
            }
        ],
        pickup: [
            {
                id: 'front',
                name: 'Front',
                name_es: 'Parte delantera',
                type: 'front',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFront',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'rear',
                name: 'Rear',
                name_es: 'Parte trasera',
                type: 'rear',
                image: undefined,
                object2detect: 'license',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRear',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'rear-left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'rearLeft',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newLeft',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'front-left',
                name: 'Left',
                name_es: 'Lat. izquierdo',
                type: 'frontLeft',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFrontLeft',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'rear-right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'rearRight',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newRight',
                uploadOK: true,
                enableAI: undefined
            },
            {
                id: 'front-right',
                name: 'Right',
                name_es: 'Lat. derecho',
                type: 'frontRight',
                image: undefined,
                object2detect: 'wheel',
                bgImage: '../../assets/images/logo/camera.svg',
                isBGShow: true,
                newImg: 'newFrontRight',
                uploadOK: true,
                enableAI: undefined
            }
        ]
    };
    static logAction(action, useCase) {
        const LOG_ACTIONS = {
            'The user has started the selfadjust': 'selfadjust_started',
            'The user has passed the landing page': 'user_landing_passed',
            'GPS Permissions were accepted': 'user_gps_accepted',
            'GPS Permissions were denied': 'user_gps_denied',
            'The image with the selected parts has been uploaded': 'parts_image_uploaded',
            'The user has selected the damaged parts of the car': 'user_parts_selected',
            'The user has uploaded a picture of the damages': 'damage_pictures_uploaded',
            'The user has finished taking the pictures of the damages': 'damage_pictures_finished',
            'The user has answered the question regarding damages': 'damage_question_finished',
            'The user has uploaded a picture of a document': 'document_pictures_uploaded',
            'The user has finished taking pictures of the documents': 'document_pictures_finished',
            'The user has given the feedback about the selfadjust': 'user_feedback_given',
            'The user has finished the selfadjust': 'user_selfadjust_finished',
            'The user has filled and sent a form': 'user_form_sent',
            'The user has uploaded a picture of a side of the car': 'side_picture_uploaded',
            'The user has finished taking pictures of the sides of the car': 'side_picture_finished',
            'The user has accepted the camera permissions': 'user_camera_accepted',
            'The user has denied the camera permissions': 'user_camera_denied',
            'An image has been uploaded': 'image_uploaded',
            'A document has been uploaded': 'document_uploaded',
            'The user has signed the selfadjust': 'user_signature_finished',
            "The user's signature has been uploaded": 'user_signature_uploaded',
            'The user has selected a repair center.': 'repair_center_selected',
            'User selected repair center': 'repair_center_selected',
            'User moved damage to the report': 'report_damage_moved',
            'User added damage to the report': 'report_damage_added',
            'A screen was finished': 'screen_finished',
            'The selfadjust was opened': 'selfadjust_opened',
            'The selfadjust was created': 'selfadjust_created',
            'The selfadjust was finished': useCase === 'Underwriting' ? 'admin_panel_finish_smartphoto_underwriting' : 'admin_panel_finish_smartphoto_claim',
            'The selfadjust was reviewed': 'selfadjust_reviewed',
            'The selfadjust was rated': 'admin_panel_rate_smartphoto',
            'The selfadjust was reopened': 'selfadjust_reopened',
            'The selfadjust was cancelled': 'selfadjust_cancelled',
            'A message regarding this selfadjust was sent.': 'selfadjust_message_sent',
            'A comment was logged.': 'comment_logged',
            'vehicle information changed': 'vehicle_info_changed',
            'vehicle information added': 'vehicle_info_added',
            'Selfadjust damage has been erased': 'damage_deleted',
            'A file has been uploaded to the selfadjust': 'file_uploaded',
            'Selfadjust info was updated': 'info_updated',
            'The selfadjust was updated': 'selfadjust_updated',
            'The repair centers were updated': 'repair_center_updated',
            'The pieces list was updated': 'carparts_list_updated',
            'The selfadjust was extended': 'selfadjust_extended',
            'The selfadjust was moved from another company': 'selfadjust_moved',
            'A listed damage has been moved to another table': 'damage_moved',
            'Selfadjust has added a new concept': 'concept_added',
            'Selfadjust has erased a new concept': 'new_concept_deleted',
            'Selfadjust damage has been added': 'damage_added',
            'Selfadjust damage has been restored': 'damage_restored',
            'The selfadjust was marked as repaired': 'selfadjust_repaired',
            'The selfadjust was reopened by workshop': 'selfadjust_reopened_by_workshop',
            'The selfadjust was reopened by workshop with a comment': 'selfadjust_reopened_by_workshop_comments'
        };
        return LOG_ACTIONS[action] ?? action;
    }
}
